import React, { useState } from "react";
import HeaderBottom from "../assets/header-bottom-shap.png"
import TripSummary from "../components/TripSummary";
import SeatSelection from "../components/SeatSelection";
import DetailsAndPayment from "../components/DetailsAndPayment";
import FinalTabsFlight from "../components/FinalTabsFlight";
import { useTranslation } from 'react-i18next'

const FlightDetails = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const steps = 4; // total steps

  const handleNext = () => {
    if (currentStep < steps - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    alert("Form submitted! ✅");
  };

  return (
      <main className="main position-relative">
        <div className="bottom-main-shap position-absolute top-0">
            <img src={HeaderBottom} alt="" />
        </div>
        <div className="steps-form-sec position-relative z-1 pt-5 pb-5">
          <div className="container">
            <div className="inner-form-sec">
              <form id="msform">
                <ul id="progressbar" className="d-flex justify-content-between list-unstyled" > 
                  {[...Array(steps)].map((_, index) => (
                    <li key={index} className={index <= currentStep ? "active" : ""}></li>
                  ))}
                </ul>

                <div className="progress">
                  <div className="progress-bar" style={{ width: `${((currentStep + 1) / steps) * 100}%` }}></div>
                </div>

                {/* Step 1 */}

                {currentStep === 0 && (
                  <div className="stups-form-sec pt-3">
                    <div className="stups-form-box">
                      <div className="trip-box-details">
                        <TripSummary />
                      </div>
                      <div className="row">
                        <div className="col-lg-8 col-md-12">
                          <div className="btn-box-com-bottom d-flex justify-content-end mt-4 gap-2">
                            <button type="button" className="next btn btn-primary" onClick={handleNext}>
                              {t("continue")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Step 2 */}

                {currentStep === 1 && (
                  <div className="stups-form-sec pt-3">
                    <div className="stups-form-box">
                      <div className="trip-box-details">
                        <SeatSelection />
                      </div>
                      <div className="row">
                        <div className="col-lg-8 col-md-12">
                          <div className="btn-box-com-bottom d-flex justify-content-between mt-4 gap-2">
                            <button type="button" className="previous btn btn-grey-box border-0" onClick={handlePrevious}>
                              {t("back")}
                            </button>
                            <button type="button" className="next btn btn-primary" onClick={handleNext}>
                              {t("continue")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Step 3 */}

                {currentStep === 2 && (
                  <div className="stups-form-sec pt-3">
                    <div className="stups-form-box">
                      <div className="trip-box-details">
                        <DetailsAndPayment />
                      </div> 
                      <div className="row">
                        <div className="col-lg-8 col-md-12">
                          <div className="btn-box-com-bottom d-flex justify-content-between mt-4 gap-2">
                            <button type="button" className="previous btn btn-grey-box border-0" onClick={handlePrevious}>
                              {t("back")}
                            </button>
                            <button type="button" className="next btn btn-primary" onClick={handleNext}>
                              {t("pay")} ₹ 10,132.13
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Step 4 */}

                {currentStep === 3 && (
                  <div className="stups-form-sec pt-3">
                    <div className="stups-form-box">
                      <div className="trip-box-details">
                        <FinalTabsFlight />
                      </div>
                      <div className="row">
                        <div className="col-lg-8 col-md-12">
                          <div className="btn-box-com-bottom d-flex justify-content-between mt-4 gap-2">
                            <button type="button" className="previous btn btn-grey-box border-0" onClick={handlePrevious}>
                              {t("back")}
                            </button>
                            <button type="button" className="next btn btn-primary" onClick={handleSubmit}>
                              {t("submit")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </main>
  );
};

export default FlightDetails;
